import { Box, Text } from "@mantine/core";

interface Props {
  text: string;
  label?: string;
  sectionId?: string;
}

export function LegacyHistoricalText({ text, label, sectionId }: Props) {
  return (
    <Box mt="8pt" data-historical-section-id={sectionId}>
      {label && (
        <Text fw={700} size="11pt">
          {label}
        </Text>
      )}
      <Text
        component="div"
        size="11pt"
        c="var(--mantine-color-black)"
        style={{
          whiteSpace: "pre-wrap",
          overflowWrap: "anywhere",
          lineHeight: 1.15,
        }}
      >
        {text}
      </Text>
    </Box>
  );
}
